import VT from '@/store/types';

export default {
  [VT.USERS_LIST]: (state, { data, status }) => {
    state.usersList = { data, status };
  },
  [VT.USER_CREATE_DATA]: (state, { data, status }) => {
    state.userCreateData = { data, status };
  },
  [VT.USER_UPDATE_DATA]: (state, { data, status }) => {
    state.userUpdateData = { data, status };
  },
  [VT.USER_CREATE]: (state, { data, status }) => {
    state.userCreate = { data, status };
  },
  [VT.USER_UPDATE]: (state, { data, status }) => {
    state.userUpdate = { data, status };
  },
  [VT.USER_UPDATE_ACTIVE]: (state, { data, status }) => {
    state.userUpdateActive = { data, status };
  },
};
